import { AUTH_TOKEN_KEY } from "../config/authToken";
import languageConfig from "../config/languageConfig";

/** Clear JWT and send user to sign-in (preserves /:lang prefix when present). */
export function clearAuthAndRedirectToSignIn() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(AUTH_TOKEN_KEY);
  } catch (_) {
    /* ignore */
  }
  const path = window.location.pathname || "/";
  const seg = path.split("/").filter(Boolean)[0];
  const urlCodes = languageConfig.getUrlCodes();
  const signin = urlCodes.includes(seg) ? `/${seg}/signin` : "/signin";
  if (!path.startsWith(signin)) {
    window.location.assign(signin);
  }
}
